import useSWRMutation from 'swr/mutation';
import fetcher from 'lib/fetcher';
import { toast } from 'react-toastify';

const useFavoriteFacilityItemRevert = (favoriteListId: number, facilityId: number) => {
  async function fetchFavoriteListItemRevert(url: string) {
    try {
      const data = await fetcher.patch(url);
      if (data?.error) {
        return toast.error(`Не удалось вернуть объект в список`, { autoClose: 5000 });
      }
      toast.success(`Объект успешно возвращен`, { autoClose: 5000 });
      return data.result;
    } catch (error) {
      throw toast.error(`Не удалось вернуть объект в список`, {
        autoClose: 5000,
      });
    }
  }

  const { data, error, isMutating, ...rest } = useSWRMutation(
    `/favourites/list/revert/${favoriteListId}/${facilityId}`,
    fetchFavoriteListItemRevert,
  );

  return { data, error, isMutating, ...rest };
};

export default useFavoriteFacilityItemRevert;
